module.exports = __webpack_public_path__ + "static/media/designIcon.5afdf5d4.svg";